export default "__VITE_ASSET__5a4be27f__"